import { render, staticRenderFns } from "./Exhibitions.vue?vue&type=template&id=77888a18&scoped=true&"
import script from "./Exhibitions.vue?vue&type=script&lang=js&"
export * from "./Exhibitions.vue?vue&type=script&lang=js&"
import style0 from "./Exhibitions.vue?vue&type=style&index=0&id=77888a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77888a18",
  null
  
)

export default component.exports